<template>
  <div class="qualify">
    <div class="qualifylist">
      <div class="qualifysingle" v-for="(i, j) in qualifylist" :key="j">
        <div class="imgbg">
          <img
            class="qimg"
            :src="i.url"
            alt=""
            @click="previewimg(i.url, i.title)"
          />
        </div>
        <div class="qname">{{ i.title }}</div>
      </div>
    </div>
    <el-dialog :visible.sync="showimg" width="90%">
      <div class="previewcon">
        <div class="dialogbg">
          <img style="width: 49.33vw; height: 68vw" :src="imgurl" alt="" />
        </div>
        <p style="font-size: 14px; text-align: center; width: 100%">
          {{ showname }}
        </p>
      </div>
      <div class="mcancel">
        <img
          src="../../assets/image/mcancel.png"
          alt=""
          style="width: 10.67vw; height: 10.67vw"
          @click="showimg = false"
        />
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      qualifylist: [],
      showimg: false,
      imgurl: "",
      showname: "",
    };
  },
  mounted() {
    this.getlist();
  },
  methods: {
    async getlist() {
      let data = {
        category: "企业概况/企业资质",
      };
      let res = await this.$http.plist(data);
      if (res.code == 200) {
        this.qualifylist = res.data;
      }
    },
    previewimg(e, v) {
      this.showimg = true;
      this.imgurl = e;
      this.showname = v;
    },
  },
};
</script>

<style scoped lang="less">
.mcancel {
  width: 100%;
  height: 10.67vw;
  display: flex;
  justify-content: center;
  align-items: center;
}
.previewcon {
  .dialogbg {
    width: 83.2vw;
    height: 83.2vw;
    background: rgba(247, 249, 252, 1);
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 2.67vw;
  }
  width: 100%;
  height: 98.67vw;
  background: rgba(247, 249, 252, 1);
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding-top: 3.73vw;
  margin-bottom: 5.33vw;
}
.qualify {
  .qualifylist {
    .qualifysingle {
      .qname {
        font-size: 12px;
        text-align: center;
        color: #06192d;
        overflow: ellipse;
        margin-top: 1.3vw;
        width: 38.67vw;
      }
      .imgbg {
        .qimg {
          width: 24vw;
          height: 33.07vw;
        }
        width: 37.6vw;
        height: 37.6vw;
        background: #f7f9fc;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      width: 44vw;
      height: 51.47vw;
      background: #fff;
      padding: 1.25vw;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    .qualifysingle:hover {
      margin-top: -0.52vw;
      border-bottom: 0.21vw solid #1961ac !important;
    }
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    gap: 2.08vw;
  }
  width: 100%;
  background: url("../../assets/image/qualifybg.png") no-repeat;
  background-position: 0 0;
  background-size: 100% 100%;
}
::v-deep .el-dialog {
  background: transparent;
  box-shadow: unset;
}
::v-deep .el-dialog__header {
  display: none;
}
::v-deep .el-dialog__body {
  background: transparent;
  height: 114.67vw;
  padding: 0;
}
::v-deep .el-icon-close {
  font-size: 1.88vw !important;
  color: rgba(0, 0, 0, 0.6) !important;
  line-height: 1.88vw;
}
::v-deep .el-dialog__headerbtn {
  top: 1.15vw;
}
</style>
